import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccountBalanceModule } from '@frontend/sports/account-balance/feature';

import { WalletTypeContainerComponent } from './wallet-type-container.component';

@NgModule({
    imports: [CommonModule, AccountBalanceModule],
    declarations: [WalletTypeContainerComponent],
    exports: [WalletTypeContainerComponent],
})
export default class WalletTypeContainerModule {}
